export enum FileUsage {
  FormatMatcher = "FormatMatcher",
  UserUpload = "UserUpload",
}
